import Swiper from 'swiper';

export default {
    init(el) {
        let options = JSON.parse(el.dataset.options),
            navigation = {},
            prev = el.querySelector('.swiper-button-prev'),
            next = el.querySelector('.swiper-button-next');

        if ( prev && next ) {
            navigation = {
                navigation: {
                    nextEl: next,
                    prevEl: prev
                }
            }
        }
        let mergedOptions = {...options, ...navigation};
        let slider = new Swiper(el.querySelector('.swiper-container'), mergedOptions);
    }
}
